import type { MessageBodyData } from './MessageBody';

interface AssistantHeaderProps {
  status?: string;
  meta?: MessageBodyData['meta'];
}

export function AssistantHeader({ status, meta }: AssistantHeaderProps) {
  const streamingLabel = status ? status.replace(/[.…]+$/, '') : '';
  const isStreaming = streamingLabel.length > 0;

  let label: string;
  if (isStreaming) {
    label = streamingLabel;
  } else if (meta?.durationSeconds != null && Number.isFinite(meta.durationSeconds)) {
    label = `Kairos · ${meta.durationSeconds.toFixed(1)}s`;
  } else {
    label = 'Kairos';
  }

  return (
    <div
      className={`assistant-header${isStreaming ? ' is-streaming' : ''}`}
      aria-live="polite"
    >
      <span className="assistant-header__mark" aria-hidden="true" />
      <span>{label}</span>
      {isStreaming && (
        <span className="assistant-header__dots" aria-hidden="true">
          <span /><span /><span />
        </span>
      )}
    </div>
  );
}
